import { CardContent, CardHeader } from '@mui/material';
import { Chart } from '../Chart';
import { LoadingCard } from '../LoadingCard';
import { useEmployeeCutMaterialsQuery } from '@features/redux/apis/cut';
import { MaterialIdMap } from '@consts/materials';
import { EmployeeEffects } from './EmployeeEffects';

type EmployeeMaterialsCardProps = {
    employeeEmail: string;
    locationId: number;
    startDate?: string;
    endDate?: string;
};

export const EmployeeMaterialsCard = ({ employeeEmail, locationId, ...dates }: EmployeeMaterialsCardProps) => {
    const queryState = useEmployeeCutMaterialsQuery({
        LocationID: locationId,
        EmployeeEmail: employeeEmail,
        ...dates,
    });
    const { data: employeeMaterials, isFetching: loading } = queryState;

    return (
        <>
            <EmployeeEffects queryState={queryState} typeOfData='cut materials data' />

            <LoadingCard loading={loading}>
                <CardHeader title='% of Cuts by Material' />

                <CardContent
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        '& [data-highcharts-chart] ': {
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        },
                    }}>
                    <Chart
                        map={false}
                        loading={false}
                        hasData={!loading && Boolean(employeeMaterials?.length)}
                        height={250}
                        options={{
                            chart: { type: 'pie', animation: false, height: 250, width: 500 },
                            legend: {
                                layout: 'vertical',
                                align: 'center',
                                verticalAlign: 'middle',
                                padding: 20,
                                x: 150,
                                maxHeight: 250,
                                labelFormat: '{name}: ({x}) <b>{y}%</b>',
                                maxWidth: 200,
                            },
                            plotOptions: {
                                pie: {
                                    center: ['40%', '50%'],
                                    allowPointSelect: false,
                                    cursor: 'pointer',
                                    dataLabels: { enabled: false },
                                    showInLegend: true,
                                },
                                series: { animation: { duration: 0 } },
                            },
                            title: 'Cut % by Material',
                            credits: { enabled: false },
                            tooltip: { pointFormat: '{point.name}: ({point.x}) <b>{point.y}%</b>' },
                            series: [
                                {
                                    data:
                                        employeeMaterials?.map(({ MaterialID, PercentOfTotalCuts, NumCuts }) => ({
                                            name: MaterialIdMap[MaterialID]?.[0] || 'Unknown',
                                            y: PercentOfTotalCuts,
                                            x: NumCuts,
                                        })) || [],
                                },
                            ],
                        }}
                    />
                </CardContent>
            </LoadingCard>
        </>
    );
};
